import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import ezProLogo from '../../assets/img/ez_logo_original_rectangular.jpg'
import HOCLoader from "../../components/HOC/HOCLoader.jsx";

class BookingSuccessScreenNew extends Component {
        constructor(props) {
        super(props);

        this.state = {
            bookingSuccessDataPrev: this.props.history.location.state.bookingSuccessData.data,
            isLoading: this.props.history.location.state.loading
        };
    }
    componentDidMount() {
        console.log("bookingSuccessDataPrev", this.state.bookingSuccessDataPrev);
        console.log("loading state", this.state.isLoading)
        setTimeout(() => {
            this.setState({ isLoading: false });
          }, 2000);
    }

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>

        );
    };

    render() {
        var well={
            boxShadow: "2px 1px 5px #ddd",
            backgroundColor: '#fff',
            padding: 10,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: 5
        }

        // console.log(">>>>this.state.serviceDataPrev", this.state.serviceDataPrev);
        // console.log(this.props,' in profileDashboard')
        return (
            <HOCLoader
            loading = {this.state.isLoading}
            >
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew
                                title='Booking Success Page' 
                                goback={() => this.props.history.goBack(null)} 
                            />
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign:'center'
                            }}>
                                <img 
                                    src={ezProLogo} 
                                    alt='logo'
                                    style={{
                                        width: '30%',
                                        height: '30%',
                                        borderRadius: 5
                                    }}
                                />
                                <p style={{
                                    fontSize: 20
                                }}>Thank you for your booking!  We work with only the best contractors in your area.</p>
                                <p style={{
                                    marginTop: 20,
                                    fontSize: 17
                                }}>You can view and edit your booking under Manage Bookings in the menu.
                                Your Booking Number is {this.state.bookingSuccessDataPrev.booking_number}
                                    {/* {this.state.bookingSuccessDataPrev.booking_number} */}
                                </p>
                            </div>
                            <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginTop: 70
                                }}>
                                    <p 
                                    onClick={()=> this.props.history.push('/user/dashboard') }
                                    style={{
                                        backgroundColor: '#0078ff',
                                        padding: 10,
                                        color: '#fff',
                                        borderRadius: 5,
                                        fontSize: 17,
                                        textAlign: 'center',
                                        cursor:'pointer'
                                    }}>Back to Dashboard</p>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            </HOCLoader>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader
    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(BookingSuccessScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/BookingSuccessScreenNew.jsx